<template>
  <div class="border-2 flex flex-col bg-white">
    <div class="p-2 w-full">
      {{ data.label }}
    </div>
    <div class="flex items-center justify-center border-t">
      <button
        @click.stop="data?.onAddElement"
        @dblclick.stop=""
        class="flex items-center justify-center hover:bg-primary-500 hover:text-white p-2"
      >
        <span class="material-symbols-outlined">add</span>
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { type NodeProps } from "@vue-flow/core";

const { data } = defineProps<
  NodeProps<{
    label: string;
    onAddElement: () => void;
  }>
>();
</script>
